import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function HeroSection() {
  return <section id="inicio" className="relative min-h-screen flex items-center justify-center overflow-hidden" data-id="element-126">
      <div className="absolute inset-0 z-0" style={{
      backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/cLFMUeBUcL2pFPsez4kxct/unnamed_(2).webp")',
      backgroundPosition: 'center',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat'
    }} data-id="element-127">
        <div className="absolute inset-0 bg-black/50" data-id="element-128" />
      </div>

      <div className="relative z-10 text-center px-4 max-w-4xl mx-auto mt-16" data-id="element-129">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.2
      }} className="mb-6 flex justify-center" data-id="element-130">
          <div className="h-px w-20 bg-laura-olive" data-id="element-131" />
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="text-laura-olive text-sm md:text-base uppercase tracking-[0.3em] mb-4" data-id="element-132">
          Asador Tradicional en Villaconejos
        </motion.h2>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="text-5xl md:text-7xl lg:text-8xl font-playfair text-laura-cream mb-6 drop-shadow-lg" data-id="element-133">
          El Rincón de Laura
        </motion.h1>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 1
      }} className="text-lg md:text-xl font-playfair italic text-laura-beige mb-12 max-w-2xl mx-auto leading-relaxed" data-id="element-134">
          Cocina casera de la Vega del Tajuña, asados en horno de leña y el
          encanto de un pueblo con historia
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 1.2
      }} className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-135">
          <a href="https://wa.me/34660343711" target="_blank" rel="noopener noreferrer" className="inline-block bg-laura-amber text-laura-dark hover:bg-laura-gold px-8 py-4 font-bold uppercase tracking-widest text-sm transition-all duration-300 shadow-lg rounded" data-id="element-136">
            Reservar Mesa
          </a>
          <a href="https://maps.google.com/?q=Calle+Emilio+de+la+Tía+Fidela+2+28360+Villaconejos+Madrid" target="_blank" rel="noopener noreferrer" className="inline-block border border-laura-cream/50 text-laura-cream hover:bg-laura-cream/10 px-8 py-4 font-bold uppercase tracking-widest text-sm transition-all duration-300 rounded" data-id="element-137">
            Cómo Llegar
          </a>
        </motion.div>
      </div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 1,
      delay: 2
    }} className="absolute bottom-8 left-1/2 -translate-x-1/2" data-id="element-138">
        <motion.div animate={{
        y: [0, 10, 0]
      }} transition={{
        repeat: Infinity,
        duration: 2,
        ease: 'easeInOut'
      }} data-id="element-139">
          <a href="#nosotros" aria-label="Scroll down" className="text-laura-olive/70 hover:text-laura-olive transition-colors" data-id="element-140">
            <ChevronDownIcon size={32} strokeWidth={1.5} data-id="element-141" />
          </a>
        </motion.div>
      </motion.div>
    </section>;
}